import { render, staticRenderFns } from "./ClipboardButton.vue?vue&type=template&id=37bd2529&scoped=true&"
import script from "./ClipboardButton.vue?vue&type=script&lang=js&"
export * from "./ClipboardButton.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardButton.vue?vue&type=style&index=0&id=37bd2529&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bd2529",
  null
  
)

export default component.exports